import React from "react";
import Testimonials, { TestimonialsProps } from "./Testimonials";

const content = [
  {
    content:
      "I am blown away by how well thought out and entertaining the game is - I was completely hooked! I know that middle schoolers will be equally as excited to play each game and pass each chapter.",
    name: "Annie Sher",
    position: "Algebra teacher at a Private School",
  },
  {
    content:
      "Several aspects of ProblemScape can trigger a good classroom conversation. Looking forward to using Problemscape with my students this upcoming school year.",
    position: "Sixth grade teacher at a US Public School",
  },
  {
    content:
      "My 10 year old already finished it and has asked if she can can start over and play it again. My 12 year old, who is known to say ‘math should go die in a hole’ actually asked to play it in her off time and went so far to admit that she likes it. So yay!!",
    name: "Melody Bowlby",
    position: "Homeschool Parent",
  },
  {
    content:
      "ProblemScape is really fun and I learned a lot. I was nervous to try Algebra, but it's been easy to learn through the game!",
    name: "Amelia B.",
    position: "Fifth grade student",
  },
];

function StandardTestimonials(
  props: Pick<TestimonialsProps, "imageBackground">,
) {
  return <Testimonials title="Testimonials" content={content} {...props} />;
}

export default StandardTestimonials;
